import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewChildren,
    AfterViewInit,
    ChangeDetectorRef
} from '@angular/core';
import {ConfirmationWithoutResponseAttributesComponent, DevexComponent} from '../devex/devex.component';
import {JsonEditorComponent} from 'ang-jsoneditor';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';
import {DevexListenerService} from '../devex-listener.service';
import {ListenerService} from '../listener.service';
import {KongService} from '../kong.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {ConnecttocrudService} from '../connecttocrud.service';
import {Location} from '@angular/common';
import {PublishServiceConfirmationComponent} from '../manage-entities/manage-entities.component';
import {error} from 'selenium-webdriver';
import {ApiintegrationsListenerService} from '../apiintegrations-listener.service';
import {FooterComponent} from '../footer/footer.component';
import {AuditLogService} from '../audit-log.service';

@Component({
    selector: 'app-api-register',
    templateUrl: './api-register.component.html',
    styleUrls: ['./api-register.component.scss']
})
export class ApiRegisterComponent implements OnInit, AfterViewInit {

    apiName: string;
    version: string;
    apiCategory: string;
    serviceProvider: string;
    mode = 'secured';
    categoryGroup: string;
    description: string;
    displayName: string;
    scope = 'public';
    registering = false;
    resetting = false;
    showResponseSection = false;
    mockResponses = [];
    @Input() executor;
    @Input() disableEdit = false;
    @Input() enableButtons = true;
    @Input() enableSave = false;
    @Output() onSavingExecutor: EventEmitter<any> = new EventEmitter<any>();
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pKey = localStorage.getItem('partnerKey');
    @Input() signInEmail = localStorage.getItem('signInEmail');
    @Input() registerType = 'registerAPI';
    @Output() APIregistered: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('devex') devexInstance: DevexComponent;
    gatewayUrl: string;
    requestBodySelected = 'none';
    registerTo = 'myAccount';
    serviceProvidersList: any;
    myControl = new FormControl();
    filteredOptions: Observable<string[]>;
    masterList: any;
    settingsData: any;
    selection: any;
    location: Location;
    // docData: any;
    // data: any;

    constructor(private confPost: ConfService, public platform: LeftpanelComponent, private dialog: MatDialog, private router: Router, public _service: ConnecttocrudService, public integrationsListener: ApiintegrationsListenerService, private auditLog: AuditLogService,
                private devexListenerInstance: DevexListenerService, private leftPanelDataListener: ListenerService, private kong: KongService, private changeDetector: ChangeDetectorRef, public footer: FooterComponent) {
    }

    // initializeData() {
    //     if (this.footer.docData) {
    //         this.docData = this.footer.docData;
    //         this.getData();
    //
    //     } else {
    //         this.confPost.getData('services', 'services', 'v1', 'referenceDocs', null).subscribe(res => {
    //             this.docData = res;
    //             this.footer.docData = this.docData;
    //             this.getData();
    //         });
    //     }
    // }
    // getData() {
    //     for (const item of this.docData) {
    //         if (item.title === 'API Register') {
    //             this.data = item;
    //         }
    //     }
    // }
    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
            this.settingsData = this.platform.settingsData;
            this.getDefaultGatewaySettings(this.settingsData);
        } else {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                    this.settingsData = settingsData;
                    this.getDefaultGatewaySettings(this.settingsData);
                }
            });
        }

        this.gatewayUrl = 'https://' + await this.platform.getDefaultGatewayURL();
        await this.getMasterList();
        this.getB2bExecutors();
    }

    ngAfterViewInit() {
        this.loadExecutor();
        this.changeDetector.detectChanges();
    }

    loadExecutor() {
        if (this.executor) {
            this.executor = JSON.parse(JSON.stringify(this.executor));
            this.apiName = this.executor.executor_name;
            this.version = this.executor.executor_version;
            this.apiCategory = this.executor.executor_category;
            this.serviceProvider = this.executor.service_provider;
            this.mode = this.executor.registeredAsIs ? 'asis' : 'secured';
            this.categoryGroup = this.executor.executor_category_group;
            this.description = this.executor.executor_description;
            this.displayName = this.executor.executor_display_name;
            this.scope = this.executor.scopeOfAccess;
            this.showResponseSection = false;
            this.devexInstance.httpOperation = this.executor.executor_method_type;
            this.devexInstance.parameterData = this.executor.queryParams ? this.executor.queryParams : [];
            this.devexInstance.headersData = this.executor.headers ? this.executor.headers : [];
            this.devexInstance.pathParameter = this.executor.pathParams ? this.executor.pathParams : [];
            this.devexInstance.authModel = this.executor.authModel;
            this.devexInstance.showResponseSection = false;
            this.devexInstance.httpUrl = this.executor.apiUrl;
            this.devexInstance.requestBodySelected = 'none';
            this.mockResponses = this.executor.mockResponses ? this.executor.mockResponses : [];
        }
    }

    async saveEmitAPI() {
        if (this.executor) {
            this.executor.executor_name = this.apiName;
            this.executor.executor_version = this.version;
            this.executor.executor_category = this.apiCategory;
            this.executor.service_provider = this.serviceProvider;
            this.executor.executor_category_group = this.categoryGroup;
            this.executor.executor_description = this.description;
            this.executor.executor_display_name = this.displayName;
            this.executor.scopeOfAccess = this.scope;
            this.executor.executor_method_type = this.devexInstance.httpOperation;
            this.executor.authModel = this.devexInstance.authModel;
            this.executor.apiUrl = this.devexInstance.httpUrl;


            this.executor.registeredAsIs = this.mode === 'secured' ? false : true;
            this.executor.queryParams = this.devexInstance.parameterData;
            this.executor.headers = this.devexInstance.headersData;
            this.executor.pathParams = this.devexInstance.pathParameter;
            this.executor.mockResponses = this.platform.validateMockResponseData(this.mockResponses);
            this.executor.requestBody = await this.devexInstance.headerChild.getRequestBody();
            this.onSavingExecutor.emit(this.executor);
        }
    }

    getDefaultGatewaySettings(settingsData) {
        for (const envs of settingsData['body'][0]['environments']) {
            if (envs && envs !== null && envs !== undefined) {
                if (envs['name'] === localStorage.getItem('partner')) {
                    if (envs['services']) {
                        const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                        for (const gateway of gatewayService[0]['configurations']) {
                            if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                this.platform.defaultGatewaySettings = gateway['gateway_configurations'];
                                this.selection = gateway['gateway_configurations'];
                            }
                        }
                    }
                }
            }
        }
    }

    getB2bExecutors() {
        this.confPost.getB2bExecutors().subscribe(response => {
            if (response) {
                let serviceProviders: any;
                this.serviceProvidersList = [];
                serviceProviders = response;
                for (const serviceProvider of serviceProviders) {
                    if (this.masterList['subscriptions']['providers'].includes(serviceProvider.id)) {
                        this.serviceProvidersList.push(serviceProvider.producer);
                    }

                }
                this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => this._filter(value))
                    );
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching service providers');
        });
    }

    _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.serviceProvidersList.filter(option => option.toLowerCase().includes(filterValue));
    }

    getMasterList() {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(response => {
                this.masterList = response['body'][0];
                resolve('success');
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching subscribed service providers');
                reject(error);
            });
        });

    }

    async subscribeToServiceProvider(provider) {
        if (this.masterList && !this.masterList['subscriptions']['providers']) {
            this.masterList['subscriptions']['providers'] = [];
        }
        this.masterList['subscriptions']['providers'].push(provider['id']);
        await this._service.patchItemUpdate(this.masterList['id'], {subscriptions: this.masterList['subscriptions']}, 'v2', 'services', 'services', 'settings').subscribe(async success => {
            //alert('Congratulations. You have activated the service provider successfully!');
            this.platform.b2bExecutors = undefined;
            await this.platform.getb2bAPIs();
            //this.avlList[card.title] = false;
        });
    }

    checkForExistingEntityOrExecutor(APIName, version) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(APIName, version)).then(response => {
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        reject('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        reject('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    resetWindow() {
        const dialogRef = this.dialog.open(ConfirmResetAPIRegisterComponent, {
            width: '60%',
            data: {}
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.resetting = true;
                this.apiName = '';
                this.version = '';
                this.apiCategory = '';
                this.serviceProvider = '';
                this.mode = 'secured';
                this.categoryGroup = '';
                this.description = '';
                this.displayName = '';
                this.scope = 'public';
                this.showResponseSection = false;
                this.devexInstance.httpOperation = 'GET';
                this.devexInstance.parameterData = [];
                this.devexInstance.headersData = [];
                this.devexInstance.pathParameter = [];
                this.devexInstance.apiByDefinition = null;
                this.devexInstance.authModel = {
                    'authAttributes': {}
                };
                this.devexInstance.showResponseSection = false;
                this.devexInstance.httpUrl = '';
                this.devexInstance.formData = [];
                this.devexInstance.requestBodySelected = 'none';
                this.mockResponses = [];
                this.resetting = false;
            }
        });
    }

    validateServiceProvider() {
        if (this.registerType === 'addAPIBlock' && this.registerTo === 'serviceProvider') {
            if (this.serviceProvider && this.serviceProvider !== '') {
                if (this.serviceProvidersList && this.serviceProvidersList.length && !this.serviceProvidersList.includes(this.serviceProvider)) {
                    this.platform.openSnackBar('Please enter a valid service provider', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    return false;
                } else {
                    if (this.categoryGroup && this.categoryGroup !== '') {
                        //const serviceProviderIndex = this.serviceProvidersList.indexOf(this.serviceProvider);
                        //this.subscribeToServiceProvider(this.serviceProvidersList[serviceProviderIndex]);
                        return true;
                    } else {
                        this.platform.openSnackBar('Please enter a valid category group', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        return false;
                    }
                }
            } else {
                this.platform.openSnackBar('Please enter a valid service provider', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                return false;
            }
        } else {
            return true;
        }
    }

    registerApi() {
        if (this.apiName && this.apiName !== '' && this.version && this.version !== '' && this.apiCategory && this.apiCategory !== '') {
            if (this.apiName.includes(' ')) {
                this.platform.openSnackBar('API Name should not contain spaces', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                const splCharRegex = /^[a-zA-Z0-9_-]+$/;
                const camelCaseRegex = /^[a-z][a-zA-Z0-9_-]*$/;

                if (splCharRegex.test(this.apiName)) {
                    if (camelCaseRegex.test(this.apiName)) {
                        if (this.devexInstance.httpUrl && this.devexInstance.httpUrl !== '') {
                            if (this.devexInstance.httpUrl.includes(' ')) {
                                this.platform.openSnackBar('URL should not contain spaces', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            } else {
                                if (this.validateServiceProvider()) {
                                    Promise.resolve(this.checkForExistingEntityOrExecutor(this.apiName, this.version)).then(async resp => {
                                        let port = 80;
                                        let dataroot = '';
                                        let host = '';
                                        let str: string;
                                        let proto: string;

                                        if (this.mode === 'secured') {
                                            str = this.devexInstance.httpUrl.slice(this.devexInstance.httpUrl.indexOf('://') + 3);
                                            proto = this.devexInstance.httpUrl.substring(0, this.devexInstance.httpUrl.indexOf(':'));
                                            if (str.search(':') === -1) {
                                                if (proto === 'https') {
                                                    port = 443;
                                                    host = str.substring(0, str.indexOf('/'));
                                                    dataroot = str.substring(str.indexOf(host) + host.length, str.length);
                                                }
                                            } else {
                                                port = +str.substring(str.indexOf(':') + 1, str.indexOf('/'));
                                                host = host = str.substring(0, str.indexOf(':'));
                                                dataroot = str.substring(str.indexOf('/'), str.length);

                                            }
                                            const temp = dataroot.split('?');
                                            dataroot = temp[0];
                                            if (this.devexInstance.headersData.filter((header) => header['key'] === 'apikey').length === 0) {
                                                this.devexInstance.headersData.push({
                                                    'key': 'apikey',
                                                    'value': '',
                                                    'description': ''
                                                });
                                            }
                                        }

                                        const apiExecutorSchema = {
                                            executor_type: 'THIRDPARTY',
                                            executor_name: this.apiName,
                                            executor_version: this.version,
                                            executor_display_name: this.displayName,
                                            executor_description: this.description,
                                            service_provider: this.serviceProvider,
                                            executor_category: this.apiCategory,
                                            executor_category_group: this.categoryGroup,
                                            published: true,
                                            scopeOfAccess: this.scope,
                                            creationTime: Date.now(),
                                            lastModifiedTime: Date.now(),
                                            partner: this.partner,
                                            account_id: this.account,
                                            executor_method_type: this.devexInstance.httpOperation,
                                            dataroot: null,
                                            queryParams: this.devexInstance.parameterData,
                                            headers: this.devexInstance.headersData,
                                            pathParams: this.devexInstance.pathParameter,
                                            requestBody: await this.devexInstance.headerChild.getRequestBody(),
                                            prerequisites: this.devexInstance.prerequisites,
                                            executors: null,
                                            responseAttributes: this.devexInstance.apiByDefinition,
                                            response: null,
                                            isDocumentationPublished: true,
                                            mockResponses: this.platform.validateMockResponseData(this.mockResponses),
                                            isMockResponseEnabled: false

                                        };

                                        if (this.mode === 'secured') {
                                            apiExecutorSchema['registeredAsIs'] = false;
                                            apiExecutorSchema['apiUrl'] = this.gatewayUrl + '/' + this.version + '/' + this.apiName;
                                        } else {
                                            apiExecutorSchema['registeredAsIs'] = true;
                                            apiExecutorSchema['apiUrl'] = this.devexInstance.httpUrl;
                                        }

                                        apiExecutorSchema['authModel'] = this.devexInstance.headerChild.authModel1.getAuthModel();

                                        if (!this.devexInstance.apiByDefinition || (this.devexInstance.apiByDefinition && this.devexInstance.apiByDefinition.length === 0)) {
                                            const dialogRef = this.dialog.open(ConfirmationWithoutResponseAttributesComponent, {
                                                width: '60%',
                                                data: apiExecutorSchema
                                            });

                                            dialogRef.afterClosed().subscribe(response => {
                                                if (response && response === 'register') {
                                                    this.register(proto, host, port, dataroot, apiExecutorSchema);
                                                }
                                            });
                                        } else {
                                            if (this.devexInstance.apiByDefinition && this.devexInstance.apiByDefinition.length === 1 && (this.devexInstance.apiByDefinition[0]['attributeName'] === null || this.devexInstance.apiByDefinition[0]['attributeName'] === '')) {
                                                const dialogRef = this.dialog.open(ConfirmationWithoutResponseAttributesComponent, {
                                                    width: '60%',
                                                    data: apiExecutorSchema
                                                });

                                                dialogRef.afterClosed().subscribe(response => {
                                                    if (response && response === 'register') {
                                                        this.register(proto, host, port, dataroot, apiExecutorSchema);
                                                    }
                                                });
                                            } else {
                                                this.register(proto, host, port, dataroot, apiExecutorSchema);
                                            }
                                        }

                                    });
                                }
                            }

                        } else {
                            this.platform.openSnackBar('API URL cannot be empty. Please provide a valid API URL', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else {
                        this.platform.openSnackBar('API Name should not start with uppercase letter.', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.platform.openSnackBar('API Name contains invalid characters. Only letters, numbers and hyphens are allowed.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }
        } else {
            this.platform.openSnackBar('Please make sure you that you have provided the API Name, Version and Category', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    async register(proto, host, port, dataroot, apiExecutorSchema) {
        this.registering = true;
        const timeStamp = Date.now();
        let partner = this.partner;
        let account = this.account;
        let pKey = this.pKey;
        let signInEmail = this.signInEmail;
        if (this.registerType === 'addAPIBlock' && this.registerTo === 'serviceProvider') {
            partner = 'b2b';
            account = 'b2b';
            pKey = '3fd7244d02a830763fcddf5c572a5b54';
            signInEmail = 'b2b@apiplatform.io';
            apiExecutorSchema['partner'] = partner;
            apiExecutorSchema['account_id'] = account;
        }
        this.confPost.insertApiExecutorForPartner(partner, account, pKey, apiExecutorSchema).subscribe(async data => {
            this.platform.createAPIAuditLog(partner, account, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', apiExecutorSchema);
            const loaderDialog2 = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            await this.platform.generateAccountRolePermissionGroupAndPermissions(partner, account, signInEmail, apiExecutorSchema['executor_name'], apiExecutorSchema['executor_version'], 'THIRDPARTY', true, timeStamp, '');

            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('thirdparty');

            let ipRestriction: boolean;
            if (apiExecutorSchema['scopeOfAccess'] === 'public') {
                ipRestriction = false;
            } else {
                ipRestriction = true;
            }

            const methods = [apiExecutorSchema['executor_method_type']];

            if (this.mode === 'secured') {

                await this.platform.configureGateway(partner, account, this.apiName, this.version, proto, host, dataroot, port, methods, ipRestriction);

                // this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, this.apiName, this.version, ipRestriction, true, methods, timeStamp, '');
                // this.devexInstance.configureApiGateway(proto, host, port, dataroot, ipRestriction);
            }

            loaderDialog2.close();
            this.registering = false;
            this.APIregistered.emit(apiExecutorSchema['executor_name'] + '_' + apiExecutorSchema['executor_version']);
            this.platform.openSnackBar('Registered the API successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            const log_payload = {
                logType: 'INFO',
                logLevel: 0,
                slugSearch: '',
                label: 'API_REGISTER',
                featureArea: this.platform.auditFeatureArea.controlplane,
                resource: 'REGISTER',
                action: 'CLICK',
                result: 'SUCCESS',
                payload: {},
                responseStatusCode: 200,
                response: {},
                errorMessage: '',
                logMessage: 'API has been registered'
            };
            this.auditLog.log(log_payload);
        }, error => {
            this.registering = false;
            this.platform.openSnackBar('Error while registering the API : ' + apiExecutorSchema.executor_name + '(' + apiExecutorSchema.executor_version + ')', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    createMarginRight() {
        document.getElementById('view:api_register').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:api_register').style.marginRight = '0px';
    }
}

@Component({
    selector: 'app-confirm-reset',
    templateUrl: 'confirm-reset-api-register.component.html',
    styleUrls: ['confirm-reset-api-register.component.css']
})
export class ConfirmResetAPIRegisterComponent implements OnInit {

    incr: any;
    progressMessage: any;
    progress = 0;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<LoaderWithProgressComponent>, public confPost: ConfService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    refreshProgressStatus(incr, progressMessage) {
        this.progress = this.progress + incr;
        this.progressMessage = progressMessage;
    }

    close() {
        this.dialogRef.close();
    }
}
